export const staticSmall = 'var(--seed-static-line-height-static-small)';
export const staticMedium = 'var(--seed-static-line-height-static-medium)';
export const staticLarge = 'var(--seed-static-line-height-static-large)';